import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Inject, Injectable } from '@angular/core';
import { SESSION_ID } from '../tokens/session-id.token';
import { WINDOW } from '@libs/shared/utilities/tokens/window.token';
import { CORALOGIX_CONFIG } from '../tokens/coralogix-config.token';
import { CoralogixConfig, LogEventParams } from '../types';
import { CoralogixService } from './coralogix.service';
import { ERROR_EVENT_ENUM, INFO_EVENT_ENUM } from '../constants';
import { merge } from '@libs/shared/utilities/utilities/object-helper';
import { firstValueFrom, Observable } from 'rxjs';
import { UserState, MerchantStoreState } from '@libs/shared/types';
import { userStateKey, merchantStoreKey } from '@libs/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private userState$: Observable<UserState>;
  private storeState$: Observable<MerchantStoreState>;
  constructor(
    private coralogixService: CoralogixService,
    @Inject(SESSION_ID) private sessionId: string,
    @Inject(CORALOGIX_CONFIG) private coralogixConfig: CoralogixConfig,
    @Inject(WINDOW) private window: Window,
    private router: Router,
    private store: Store,
  ) {
    this.userState$ = this.store.select((state: any) => state[userStateKey]);
    this.storeState$ = this.store.select((state: any) => state[merchantStoreKey]);
  }

  async logEvent(eventParams: LogEventParams): Promise<void> {
    try {
      const { type, eventName, eventPayload = {} } = eventParams;
      const traceId = `${this.coralogixConfig.appName}-${this.window.crypto.randomUUID()}`;
      const userState = await firstValueFrom(this.userState$);
      const storeState = await firstValueFrom(this.storeState$);

      const _eventPayload = merge(
        {
          pagePath: this.router.url,
          userId: userState.userId,
          email: userState.email,
          activeStore: storeState.activeStore,
          allStoresSelected: storeState.allStoresSelected,
          tags: {
            kp: {
              sessionId: this.sessionId ?? '',
              traceId: traceId ?? '',
            },
          },
        },
        eventPayload,
      );
      switch (type) {
        case 'info':
          this.coralogixService.log(eventName as INFO_EVENT_ENUM, _eventPayload);
          break;
        case 'error':
          this.coralogixService.error(eventName as ERROR_EVENT_ENUM, _eventPayload);
          break;
      }
    } catch (err) {
      console.error(err);
    }
  }
}
